export enum ProjectTimelineActionType {
    GET_PROJECT_TIMELINE = 'GET_PROJECT_TIMELINE',
    SAVE_PROJECT_TIMELINE = 'SAVE_PROJECT_TIMELINE',
}
